import { BrowserRouter } from 'react-router-dom'
import { Toaster } from 'react-hot-toast'
import { AutoRouter } from './components/auto-router'
import { Header } from './components/header/header'
import { MobileFooter } from './components/mobile-footer'
import { AppRoutes } from './components/app-routes'
import { VersionDisplay } from './components/version-display'
import { ScrollToTop } from './components/scroll-to-top'
import { PageTransition } from './components/page-transition'
import { ThemeProvider } from './components/theme-provider'
import { ErrorBoundary } from './components/error-boundary'
import { cn, contentMaxWidth } from './lib/utils'
import { useUIStore } from './store/ui-store'

function App() {
	const { editorMode } = useUIStore()

	return (
		<ErrorBoundary>
			<ThemeProvider>
				<BrowserRouter>
					<ScrollToTop />
					<AutoRouter>
						<Header />
						<div className='min-h-screen '>
							<main
								className={cn(
									'overflow-x-hidden overflow-y-scroll px-4 pb-30 mx-auto',
									editorMode
										? 'mt-[25px] h-[calc(100vh-25px)] pt-2'
										: 'mt-[var(--header-height)] h-[calc(100vh-var(--header-height))] pt-4',
									contentMaxWidth
								)}>
								<PageTransition>
									<AppRoutes />
								</PageTransition>
							</main>

							<MobileFooter />
							<VersionDisplay />
						</div>
					</AutoRouter>
					<Toaster position='top-right' />
				</BrowserRouter>
			</ThemeProvider>
		</ErrorBoundary>
	)
}

export default App
